export default "__VITE_ASSET__CI1w34CE__"